import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  useMediaQuery,
  Snackbar,
  AlertProps,
  Alert,
} from "@mui/material";
import ManufacturingMasterTable from "./NutritionManufacturingMasterTable";
import btnDownloadIcon from "../../Assests/download.svg";
import btnSaveIcon from "../../Assests/Save-btn.svg";
import {
  EditProductTableSuccess,
  ViewProductTableError,
  ViewProductTableStart,
  ViewProductTableSuccess,
} from "../../Redux/Actions/InputData";
import { postRequest, putRequest } from "../../Services/AxiosConfiguration";
import {
  API_BASE_URL,
  DOWNLOAD_NUT_MANUFACTURING_MASTER_2_TABLE_API,
  DISPLAY_MANUFACTURING_MASTER_2_TABLE_API,
  BULK_EDIT_NUT_MANUFACTURING_MASTER_API,
} from "../../Utils/Config";
import RestoreOutlinedIcon from "@mui/icons-material/RestoreOutlined";
import axios from "axios";
import FileSaver from "file-saver";
import "./style.css";
import * as actions from "../../Redux/Actions/index";
import { useTheme } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import AddRowButton from "../../Components/Common/AddRowButton";
import DeleteRowsButton from "../../Components/Common/DeleteRowsButton";
import ConfirmationDialog from "../../Components/Common/ConfirmationDialog";

function NutritionManufacturingMaster(props: any) {
  const childRef: any = useRef();
  const dispatch: any = useDispatch();
  const [selectFactory, setSelectFactory] = useState<any>("");
  const [selectProduct, setSelectProduct] = useState<any>("");
  const [selectCascade, setSelectCascade] = useState<any>("");
  const [selectLine, setSelectLine] = useState<any>("");
  const [rowsData, setRows] = React.useState<any[]>([]);
  const [isProcessed, setIsProcessed] = React.useState(false);
  const [factoryOptions, setFactoryOptions] = React.useState([]);
  const [basepackOptions, setBasepackOptions] = useState<any>([]);
  const [cascadeOptions, setCascadeOptions] = useState<any>([]);
  const [productOptions, setProductOptions] = useState<any>([]);
  const [getEditedValue, setEditedValue] = useState<any>([]);
  const [open, setOpen] = React.useState(false);

  const [filterRequest, setFilterRequest] = React.useState([
    { key: "factory", value: "" },
    { key: "[cascade]", value: "" },
    { key: "product", value: "" },
  ]);

  console.log(factoryOptions, "factoryoptions");
  const selectedUsecaseId = useSelector(
    (state: any) => state.InputDataReducers.selectedUsecaseId,
  );
  const selectedCategoryId = useSelector(
    (state: any) => state.InputDataReducers.selectedCategoryId,
  );

  const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);
  const [deletedRows, setDeletedRows] = useState<any[]>([]);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [isActionEnabled, setIsActionEnabled] = useState(false);
  const handleSelectionChange = (newSelection: any[]) => {
    setSelectedRows(newSelection);
    setIsActionEnabled(newSelection.length > 0);
  };

  var cascade = 0;
  var product = 0;
  var fact = 0;

  /**Redux state */
  const selectedFolderId = useSelector(
    (state: any) => state.InputDataReducers.selectedFolderId,
  );

  const selectedScenarioId = useSelector(
    (state: any) => state.InputDataReducers.selectedScenarioId,
  );

  const isEditPopup = useSelector(
    (state: any) => state.InputDataReducers.editPopupFlage,
  );

  var factoryCount = 0;
  const handleChangeSelectFactory = (event: any) => {
    fact = 1;
    setSelectCascade("");
    setSelectProduct("");
    filterRequest[1].value = "";
    filterRequest[2].value = "";
    const {
      target: { value },
    } = event;
    setSelectFactory(value);
    filterRequest[0].value = value;
    callTableGridApi();
    factoryCount++;
    cascade = 0;
  };

  var cascadeCount = 0;
  const handleChangeSelectCascade = (event: any) => {
    fact = 1;
    setSelectProduct("");
    filterRequest[2].value = "";
    const {
      target: { value },
    } = event;
    setSelectCascade(value);
    filterRequest[1].value = value;
    callTableGridApi();
    cascadeCount++;
    cascade = 1;
    product = 0;
  };

  var productCount = 0;
  const handleChangeSelectProduct = (event: any) => {
    fact = 1;
    const {
      target: { value },
    } = event;
    setSelectProduct(value);
    filterRequest[2].value = value;
    callTableGridApi();
    productCount++;
    cascade = 1;
    product = 1;
  };

  const handleDownload = (e: any) => {
    downloadXLSFile();
  };

  const downloadXLSFile = async () => {
    const filterList = filterRequest.filter((elem: any) => elem.value != "");
    //const requestParam =  { "usecaseId": selectedUsecaseId, "category_id": selectedCategoryId,"folder_id": selectedFolderId, "scenario_id": selectedScenarioId, "table": "tblNutritionManufacturingMaster", "time_period": "string", "filter": filterList};
    let scenarioId =
      selectedScenarioId?.scenario_id !== undefined &&
      selectedScenarioId?.scenario_id !== ""
        ? selectedScenarioId?.scenario_id
        : selectedScenarioId;
    const requestParam = {
      usecaseId: selectedUsecaseId,
      category_id: selectedCategoryId,
      folder_id: selectedFolderId,
      scenario_id: scenarioId,
      // table: selectedScenarioId === 0
      // ? "tblNutritionManufacturingMaster"
      // : "tblNutritionManufacturingMaster_Rerun",
      table:
        selectedScenarioId === 0
          ? "tblNutritionManufacturingMaster_Rerun"
          : "tblNutritionManufacturingMaster_Rerun",
      time_period: "",
      ispagination: 1,
      page: 1,
      pagesize: 100,
      filter: filterList,
    };

    // const requestParam = { "folder_id": selectedFolderId, "scenario_id": selectedScenarioId, "table": "tblManufacturing1Data", "filter": filterList };
    const urls = API_BASE_URL + DOWNLOAD_NUT_MANUFACTURING_MASTER_2_TABLE_API;
    axios({
      url: urls,
      method: "post",
      responseType: "arraybuffer",
      headers: { "Content-Type": "application/json;" },
      data: requestParam,
    }).then((response) => {
      let blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      FileSaver(blob, Date.now() + ".xlsx");
    });
  };

  const callTableGridApi = (resetfilter?: any) => {
    const filterList = filterRequest.filter((elem: any) => elem.value != "");
    //const requestParam = { "folder_id": selectedFolderId, "scenario_id": selectedScenarioId, "table": "tblManufacturing1Data", "ispagination": 1, "page": 1, "pagesize": 100, "filter": resetfilter ? resetfilter : filterList };
    // const requestParam = { "usecaseId": 1, "category_id": 1,"folder_id": selectedFolderId, "scenario_id": selectedScenarioId, "table": "tblManufacturingMaster", "time_period": "string","ispagination": 1, "page": 1, "pagesize": 100, "filter": resetfilter ? resetfilter : filterList }
    // const requestParam = { "usecaseId": selectedUsecaseId, "category_id": selectedCategoryId,"folder_id": selectedFolderId, "scenario_id": selectedScenarioId, "table": "tblNutritionManufacturingMaster", "time_period": "string","ispagination": 1, "page": 1, "pagesize": 100, "filter": resetfilter ? resetfilter : filterList }
    let scenarioId =
      selectedScenarioId?.scenario_id !== undefined &&
      selectedScenarioId?.scenario_id !== ""
        ? selectedScenarioId?.scenario_id
        : selectedScenarioId;
    const requestParam = {
      usecaseId: selectedUsecaseId,
      category_id: selectedCategoryId,
      folder_id: selectedFolderId,
      scenario_id: scenarioId,
      table:
        selectedScenarioId === 0
          ? "tblNutritionManufacturingMaster"
          : "tblNutritionManufacturingMaster_Rerun",
      time_period: "",
      ispagination: 1,
      page: 1,
      pagesize: 100,
      filter: resetfilter ? resetfilter : filterList,
    };
    dispatch(ViewProductTableStart());
    const urls = API_BASE_URL + DISPLAY_MANUFACTURING_MASTER_2_TABLE_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    postRequest(urls, requestParam, header, {})
      .then((response) => {
        if (response.status === 200 && response.data) {
          setIsProcessed(true);
          setRows(response.data);
          console.log(response.data, "response data");
          if (fact === 0) setFactoryOptions(loadFactoryOptions(response.data));
          if (cascade === 0)
            setCascadeOptions(loadCascadeOptions(response.data));
          if (product === 0)
            setProductOptions(loadProductOptions(response.data));

          dispatch(ViewProductTableSuccess(response.data));
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(ViewProductTableError(error));
      });
  };

  const loadFactoryOptions = (data: any) => {
    const factoryOptions: any = [];
    data.map((item: any) => {
      const filteredItem = factoryOptions.find((obj: any) => {
        return obj.factory_Name === item.factory;
      });
      if (filteredItem === undefined || filteredItem == null) {
        factoryOptions.push({ id: item.id, factory_Name: item.factory });
      }
    });
    return factoryOptions;
    //setFactoryOptions(factoryOptions);
  };

  const loadCascadeOptions = (data: any) => {
    const cascadeOptions: any = [];
    data.map((item: any) => {
      const filteredItem = cascadeOptions.find((obj: any) => {
        return obj.cascade === item.cascade;
      });
      if (filteredItem === undefined || filteredItem == null) {
        cascadeOptions.push({ id: item.id, cascade: item.cascade });
      }
    });
    //setLineOptions(lineOptions);
    return cascadeOptions;
  };

  const loadProductOptions = (data: any) => {
    const productOptions: any = [];
    data.map((item: any) => {
      const filteredItem = productOptions.find((obj: any) => {
        return obj.product === item.product;
      });
      if (filteredItem === undefined || filteredItem == null) {
        productOptions.push({ id: item.id, product: item.product });
      }
    });
    //setLineOptions(lineOptions);
    return productOptions;
  };

  const getfiltersApi = () => {
    const filterList = filterRequest.filter((elem: any) => elem.value != "");
    //const requestParam = { "folder_id": selectedFolderId, "scenario_id": selectedScenarioId, "table": "tblManufacturing1Data", "ispagination": 1, "page": 1, "pagesize": 100, "filter": filterList };
    //const requestParam = { "usecaseId": selectedUsecaseId, "category_id": selectedCategoryId,"folder_id": selectedFolderId, "scenario_id": selectedScenarioId, "table": "tblNutritionManufacturingMaster", "time_period": "string","ispagination": 1, "page": 1, "pagesize": 100, "filter": filterList };
    let scenarioId =
      selectedScenarioId?.scenario_id !== undefined &&
      selectedScenarioId?.scenario_id !== ""
        ? selectedScenarioId?.scenario_id
        : selectedScenarioId;
    const requestParam = {
      usecaseId: selectedUsecaseId,
      category_id: selectedCategoryId,
      folder_id: selectedFolderId,
      scenario_id: scenarioId,
      table:
        selectedScenarioId === 0
          ? "tblNutritionManufacturingMaster"
          : "tblNutritionManufacturingMaster_Rerun",
      time_period: "",
      ispagination: 1,
      page: 1,
      pagesize: 100,
      filter: filterList,
    };
    dispatch(ViewProductTableStart());
    const urls = API_BASE_URL + DISPLAY_MANUFACTURING_MASTER_2_TABLE_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    postRequest(urls, requestParam, header, {})
      .then((response) => {
        if (response.status === 200 && response.data) {
          console.log(response.data, "data");
          setFactoryOptions(loadFactoryOptions(response.data));
          setCascadeOptions(loadCascadeOptions(response.data));
          setProductOptions(loadProductOptions(response.data));
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(ViewProductTableError(error));
      });
  };

  useEffect(() => {
    callTableGridApi();
    getfiltersApi();
  }, [
    selectedUsecaseId,
    selectedCategoryId,
    selectedFolderId,
    selectedScenarioId,
  ]);

  const handleRestoreClicked = (e: any) => {
    setSelectFactory("");
    setSelectCascade("");
    setSelectProduct("");
    setFilterRequest([
      { key: "factory", value: "" },
      { key: "[cascade]", value: "" },
      { key: "product", value: "" },
    ]);
    callTableGridApi([]);
  };

  // bulk edit

  const handleFetchEditData = (val: any) => {
    console.log(val, "edited array");
    setEditedValue(val);
  };

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleAddRow = () => {
    setRows((prev: any) => {
      const emptyRow = {
        id: new Date().getTime(),
        folder_Id: selectedFolderId,
        scenario_id: selectedScenarioId,
        factory_Code: "",
        factory: "",
        format: "",
        cascade: "",
        product: "",
        capacity: 0,
        isNew: true,
      };
      return prev.length > 0 ? [...prev, emptyRow] : prev;
    });
    setTimeout(() => {
      childRef.current?.goToLastPage?.();
    }, 0);
  };
  const [snackbar, setSnackbar] = React.useState<Pick<
    AlertProps,
    "children" | "severity"
  > | null>(null);

  const handleDeleteRows = () => {
    if (!selectedRows.length) return;
    setIsDeleteConfirmOpen(true);
  };

  const handleConfirmDeleteRows = () => {
    const updatedRows: any[] = [];
    const rowsToDelete: any[] = [];

    rowsData.forEach((row: any) => {
      if (selectedRows.includes(row.id)) {
        const updated = {
          ...row,
          folder_id: 0,
          folder_Id: 0,
          scenario_id: 0,
          isDelete: true,
        };
        rowsToDelete.push(updated);
      } else {
        updatedRows.push(row);
      }
    });

    setRows(updatedRows);

    if (rowsToDelete.length > 0) {
      // Store deleted rows separately
      setDeletedRows((prev: any[]) => [...prev, ...rowsToDelete]);

      setIsDeleteConfirmOpen(false);
      setSelectedRows([]);
      setIsActionEnabled(false);

      const dataToSave =
        getEditedValue && getEditedValue.length > 0
          ? [
              ...getEditedValue.filter(
                (row: any) => row && Object.keys(row).length > 0,
              ),
              ...rowsToDelete,
            ]
          : rowsToDelete;

      handleAgree(dataToSave, "Record deleted successfully");
    } else {
      setIsDeleteConfirmOpen(false);
    }
  };

  const handleAgree = (dataToSave: any[], successMessage: string) => {
    const transformedRows = dataToSave.map((row: any) => {
      if (row.isNew) {
        const { isNew, ...rest } = row;
        rest.id = 0;
        return rest;
      }

      return row;
    });
    const urls = API_BASE_URL + BULK_EDIT_NUT_MANUFACTURING_MASTER_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    putRequest(urls, transformedRows, header, {})
      .then((response) => {
        if (response.status === 200) {
          callTableGridApi();
          setSnackbar({
            children: successMessage,
            severity: "success",
          });
          handleClose();
          childRef?.current?.ClearEditedData();
          dispatch(EditProductTableSuccess(response.data));
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        setSnackbar({
          children: "Something went wrong please try again!",
          severity: "error",
        });
        handleClose();
      });
    // setTimeout(() => {
    //   props.onClose();
    // }, 200);
  };

  const isEditEnabled = useSelector(
    (state: any) => state.InputDataReducers.editFilterEnable,
  );

  const handleEditSave = (e: any) => {
    console.log(getEditedValue, "edited data");
    handleClickOpen();
  };

  const handleCloseSnackbar = () => setSnackbar(null);

  return (
    <>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        className="Dialogbox-display"
      >
        <DialogTitle
          id="responsive-dialog-title"
          className="responsive-dialog-title-txt"
        >
          {"Confirmation for Edit"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText className="md-alert-clr">
            {getEditedValue.length > 0
              ? "Do you want to submit the edited Nutrition Manufacturing master table data?"
              : "Please Edit any value to save!"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {getEditedValue.length > 0 ? (
            <>
              <Button className="modal-btn-b" autoFocus onClick={handleClose}>
                No
              </Button>
              <Button
                className="modal-btn-b"
                onClick={() =>
                  handleAgree(getEditedValue, "Successfully saved")
                }
                autoFocus
              >
                Yes
              </Button>
            </>
          ) : (
            <Button className="modal-btn-b" autoFocus onClick={handleClose}>
              Ok
            </Button>
          )}
        </DialogActions>
      </Dialog>
      <ConfirmationDialog
        open={isDeleteConfirmOpen}
        onClose={() => setIsDeleteConfirmOpen(false)}
        onConfirm={handleConfirmDeleteRows}
        title="Confirmation for Delete"
        page="Manufacturing Master"
        confirmText="Yes"
        cancelText="No"
        fullScreen={fullScreen}
      />
      <div className="Compare">
        <div className="filter-section">
          <div className="page-title">
            <h3>Manufacturing Master</h3>
          </div>
          <div className="filters">
            <span title="Reset">
              <RestoreOutlinedIcon
                className="restoreIcon"
                onClick={(e) => handleRestoreClicked(e)}
              />
            </span>
            <AddRowButton
              isEditEnabled={isEditEnabled && !isActionEnabled}
              handleAddRow={handleAddRow}
            />
            <DeleteRowsButton
              isEditEnabled={isEditEnabled && isActionEnabled}
              handleDeleteRows={handleDeleteRows}
            />
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                {/* <InputLabel>Factory</InputLabel> */}
                <Select
                  id="simple-select-1"
                  value={selectFactory}
                  placeholder="Select Factory"
                  onChange={handleChangeSelectFactory}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Factory</em>
                  </MenuItem>
                  {factoryOptions?.map((d: any) => {
                    // return (<MenuItem key={d} value={d.factory}>{d.factory}</MenuItem>)
                    return (
                      <MenuItem key={d} value={d.factory_Name}>
                        {d.factory_Name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                {/* <InputLabel>Cascade</InputLabel> */}
                <Select
                  id="simple-select-2"
                  value={selectCascade}
                  placeholder="Select Cascade"
                  onChange={handleChangeSelectCascade}
                  // renderValue={(selectCascade: any) => selectCascade}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Cascade</em>
                  </MenuItem>
                  {cascadeOptions?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.cascade}>
                        {d.cascade}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                {/* <InputLabel>Product</InputLabel> */}
                <Select
                  id="simple-select-4"
                  value={selectProduct}
                  placeholder="Select Basepack"
                  onChange={handleChangeSelectProduct}
                  // renderValue={(selectProduct: any) => selectProduct}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Product</em>
                  </MenuItem>
                  {productOptions?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.product}>
                        {d.product}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            {isEditEnabled && isEditPopup && (
              <FormControl fullWidth>
                <div
                  className="content-save-btn"
                  onClick={(e) => handleEditSave(e)}
                >
                  <img src={btnSaveIcon} alt="" /> <span> Save</span>
                </div>
              </FormControl>
            )}
            <div className="filter-item">
              <FormControl fullWidth>
                <div
                  className={`content-download-btn ${
                    isActionEnabled ? "disabled" : ""
                  }`}
                  onClick={(e) => handleDownload(e)}
                >
                  <img src={btnDownloadIcon} alt="" /> <span> Download</span>
                </div>
              </FormControl>
            </div>
          </div>
        </div>
      </div>
      <div>
        <ManufacturingMasterTable
          ref={childRef}
          isProcessed={isProcessed}
          rowsData={rowsData}
          handleGetEditData={handleFetchEditData}
          setRows={setRows}
          handleSelectionChange={handleSelectionChange}
          selectedRows={selectedRows}
        />
        {!!snackbar && (
          <Snackbar
            open
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={handleCloseSnackbar}
            autoHideDuration={6000}
          >
            <Alert {...snackbar} onClose={handleCloseSnackbar} />
          </Snackbar>
        )}
      </div>
    </>
  );
}

export default NutritionManufacturingMaster;
